module.exports = __webpack_public_path__ + "assets/img/logo.994334d6.svg";